import { getLocale } from "../runtime";

const sv_searchbarlabel = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vad letar du efter?`
};

const searchbarlabel = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_searchbarlabel(inputs)
	return "searchBarLabel";
};

export { searchbarlabel as "searchBarLabel" };